import { render, staticRenderFns } from "./ProjectBanner.vue?vue&type=template&id=b6b79c4c&scoped=true&"
import script from "./ProjectBanner.vue?vue&type=script&lang=js&"
export * from "./ProjectBanner.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBanner.vue?vue&type=style&index=0&id=b6b79c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b79c4c",
  null
  
)

export default component.exports